(function () {

  'use strict';

  function pxWorkflows($location) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        showSection: '=showSection',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/workflows/workflows.template.html',
      link: function (scope) {

        scope.changeSettingsSection = function (section) {
          scope.showSection = section;
          const url = $location.path();
          $location.path(url, false).search({ settingsSection: section });
        };

      }
    };
  }

  pxWorkflows.$inject = [
    '$location'
  ];

  angular
    .module('printix-admin')
    .directive('pxWorkflows', pxWorkflows);

})();
